<template>
  <div class="tire-recommend">
    <div class="model-name" @click="goHome">
      {{ this.$route.query.brand_name ? this.$route.query.brand_name : "--" }} -
      {{ this.$route.query.factory_name ? this.$route.query.factory_name : "--"
      }}<i
        style="margin-left: 6px; color: #333"
        class="iconfont icon-arrowR font-10"
      />
    </div>
    <div
      class="basic-info"
      v-if="
        !(
          !notEmpty(tireSpec) &&
          !notEmpty(maintainInfo) &&
          tireInfo.length == 0
        )
      "
    >
      <div class="sub-title">基本信息</div>
      <div
        v-if="tireInfo.length > 0"
        :class="{
          'products-box': true,
          'single-box': tireInfo.length === 1,
          'two-box': tireInfo.length === 2,
          'three-box': tireInfo.length > 2,
        }"
      >
        <div class="product-box" v-for="(item, index) in tireInfo" :key="index">
          <img
            @click="preview(item.imageUrls)"
            :src="item.imageUrls[0]"
            alt=""
          />
          <span>{{ item.brandName + " " + item.nickName }}</span>
        </div>
      </div>
      <div v-else class="empty">
        <div class="empty-box">
          <img class="empty-img" src="@/assets/maintenance/empty-bg.png" />
          <span>暂无产品推荐～</span>
        </div>
      </div>
    </div>
    <div class="spec" v-if="notEmpty(tireSpec)">
      <div class="sub-title">轮胎规格</div>
      <table>
        <tr>
          <th>前轮胎规格</th>
          <th class="content">{{ tireSpec.front_attrs }}</th>
        </tr>
        <tr>
          <td>后轮胎规格</td>
          <td class="content">{{ tireSpec.after_attrs }}</td>
        </tr>
        <tr>
          <td>轮毂规格</td>
          <td class="content">
            {{ tireSpec.wheel_hub_attrs ? tireSpec.wheel_hub_attrs : "--" }}
          </td>
        </tr>
      </table>
    </div>
    <div class="tire-pressure" v-if="notEmpty(maintainInfo)">
      <div class="sub-title">胎压复位</div>
      <div class="item" v-if="maintainInfo.tpms">
        <div class="left">胎压报警灯</div>
        <div class="right">{{ maintainInfo.tpms }}</div>
      </div>
      <div class="item" v-if="maintainInfo.tireSensor">
        <div class="left">胎压传感器</div>
        <div class="right">{{ maintainInfo.tireSensor }}</div>
      </div>
      <div class="item" v-if="maintainInfo.sensorRate">
        <div class="left">胎压传感器频率</div>
        <div class="right">{{ maintainInfo.sensorRate }}</div>
      </div>
      <div v-if="maintainInfo.advice" :class="{ item: true, multiple: true }">
        <div class="left">技师建议</div>
        <div class="right">
          {{ maintainInfo.advice }}
        </div>
      </div>
    </div>
    <div
      class="all-empty"
      v-if="
        !notEmpty(tireSpec) && !notEmpty(maintainInfo) && tireInfo.length == 0
      "
    >
      <div class="empty-box">
        <img
          src="@/assets/maintenance/empty-bg.png"
          class="empty-img"
          alt="empty"
        />
        <span>暂无数据～</span>
      </div>
    </div>
    <MediaView v-if="mediaList.flat().length > 0" :mediaList="mediaList" />
  </div>
</template>
<script>
import MediaView from "./components/MediaView.vue";
import { setStatistics } from "@/utils/common";
import api from "@/apis/maintenance-api.js";
import { userQueryCarModelRecord } from "@/utils/data-burial";
import validToken from "@/mixins/valid-token.js";
export default {
  mixins: [validToken],
  components: { MediaView },
  data() {
    return {
      selectedInfo: {},
      tireInfo: {},
      maintainInfo: {},
      mediaList: [[], []],
      tireSpec: {
        front_attrs: "",
        after_attrs: "",
        wheel_hub_attrs: "",
      },
      vehicle_id: "",
    };
  },
  async mounted() {
    this.selectedInfo = this.$route.query;
    await this.fetchDetail();
    await this.queryDataRecord();
    // console.log(this.tireInfo, this.maintainInfo, this.tireSpec);
  },
  methods: {
    goHome() {
      this.$router.push({
        path: "/home",
        query: {
          id: this.$route.query.scheme_id,
        },
      });
    },
    async fetchDetail() {
      await this.fetchValidToken();
      if (!this.token) return;
      this.$loading.show("加载中...");
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const {
        brand_name,
        model_alias,
        factory_name,
        sales_name,
        release_year,
        displacement,
      } = this.selectedInfo;
      const params = {
        brand_name,
        model_alias,
        displacement,
        factory_name,
        sales_name,
        release_year,
        parts_type: 3,
        vehicle_ids: this.$route.query.id ? [this.$route.query.id] : [],
        token: this.token,
        scheme_id,
      };
      try {
        const res = await api.getModelDetail(params);
        if (
          res.code !== 0 &&
          (res.code === 40800 ||
            res.code === 40700 ||
            res.code === 40900 ||
            res.code === 40910)
        ) {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
          return;
        }
        this.vehicle_id =
          res.data.vehicle_list && res.data.vehicle_list[0]
            ? res.data.vehicle_list[0].id
            : this.$route.query.id
            ? this.$route.query.id
            : "";
        // set 轮胎信息
        if (this.$route.query.key === "default" || !this.$route.query.key) {
          this.tireInfo = res.data.parts_list[0]
            ? res.data.parts_list[0].merge_parts
            : [];
          // 设置前后轮规格
          this.tireSpec.front_attrs =
            res.data.parts_list[0].front_attrs.length > 0
              ? res.data.parts_list[0].front_attrs.reduce((res, cur) => {
                  res = `${res} ${cur[0].attrValue}`;
                  return res;
                }, "")
              : "";
          this.tireSpec.after_attrs =
            res.data.parts_list[0].after_attrs.length > 0
              ? res.data.parts_list[0].after_attrs.reduce((res, cur) => {
                  res = `${res} ${cur[0].attrValue}`;
                  return res;
                }, "")
              : "";
          // 设置轮毂规格
          this.tireSpec.wheel_hub_attrs = `${
            res.data.parts_list[0].front_wheel_hub
              ? res.data.parts_list[0].front_wheel_hub
              : "--"
          }/${
            res.data.parts_list[0].after_wheel_hub
              ? res.data.parts_list[0].after_wheel_hub
              : "--"
          }`;
          if (this.tireSpec.wheel_hub_attrs == "--/--") {
            this.tireSpec.wheel_hub_attrs = "";
            if (this.notEmpty(this.tireSpec)) {
              this.tireSpec.wheel_hub_attrs == "--/--";
            }
          }
        } else {
          let curInfo = res.data.parts_list.find(
            (i) => i.key == this.$route.query.key
          );
          this.tireInfo = curInfo.merge_parts;
          // 设置前后轮规格
          this.tireSpec.front_attrs =
            curInfo.front_attrs.length > 0
              ? curInfo.front_attrs.reduce((res, cur) => {
                  res = `${res} ${cur[0].attrValue}`;
                  return res;
                }, "")
              : "";
          this.tireSpec.after_attrs =
            curInfo.after_attrs.length > 0
              ? curInfo.after_attrs.reduce((res, cur) => {
                  res = `${res} ${cur[0].attrValue}`;
                  return res;
                }, "")
              : "";
          this.tireSpec.wheel_hub_attrs = `${
            curInfo.front_wheel_hub ? curInfo.front_wheel_hub : "--"
          }/${curInfo.after_wheel_hub ? curInfo.after_wheel_hub : "--"}`;
          if (this.tireSpec.wheel_hub_attrs == "--/--") {
            this.tireSpec.wheel_hub_attrs = "";
            if (this.notEmpty(this.tireSpec)) {
              this.tireSpec.wheel_hub_attrs == "--/--";
            }
          }
        }
        // 设置养护信息
        // if (this.$route.query.key == "default" || !this.$route.query.key) {
        // 轮胎不同key只对应同一个养护信息，推荐轮胎与轮胎规格按key筛选
        if (res.data.datum_list.length > 0) {
          let maintainTemp = res.data.datum_list[0].datum_detail.datumAttrs;
          this.maintainInfo = maintainTemp.reduce((res, cur) => {
            res[`${cur.attrKey}`] = cur.attrValue;
            return res;
          }, {});
          this.sortMedia(res.data.datum_list[0].datum_detail.datumImages);
        }
        // } else {
        //   let maintainTemp = res.data.datum_list.find(
        //     (i) => i.key === this.$route.query.key
        //   );
        //   this.maintainInfo = maintainTemp.datum_detail.datumAttrs;
        //   this.maintainInfo = this.maintainInfo.reduce((res, cur) => {
        //     res[`${cur.attrKey}`] = cur.attrValue;
        //     return res;
        //   }, {});
        //   this.sortMedia(maintainTemp.datum_detail.datumImages);
        // }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    sortMedia(mediaArrs) {
      let temp1 = mediaArrs
        .filter((i) => i.resName === "胎压灯复位指导" && i.resType == 0)
        .map((i) => i.resUrl);
      // TODO-视频
      // let temp2 = mediaArrs
      //   .filter((i) => i.resName === "胎压灯复位指导" && i.resType == 1)
      //   .map((i) => i.resUrl);
      // let tempArr = [];
      // temp2.length > 0 && temp2.forEach((i) => tempArr.push(i));
      temp1.length == 0 ? (temp1 = []) : "";
      this.mediaList = [temp1];
    },
    preview(imgsArr, idx = 0) {
      this.$imagePreview({
        images: imgsArr,
        index: idx,
        defaultOpt: {
          fullscreenEl: false,
          arrowEl: true,
          preloaderEl: true,
          bgOpacity: 0.85,
          preload: [1, 1],
          showHideOpacity: true,
          showAnimationDuration: 0,
        },
      });
    },
    // 判断字符串的对象，有一个键不为空，返回true
    notEmpty(obj) {
      return !!Object.keys(obj).find((i) => obj[i] != "");
    },
    // 查询数据记录
    async queryDataRecord() {
      if (!window.localStorage.getItem("OILUSER")) {
        await setStatistics.apply(this, []);
      }
      const uuid = window.localStorage.getItem("OILUSER")
        ? Number(window.localStorage.getItem("OILUSER"))
        : "";
      const { internal_from } = this.$route.query;
      const {
        brand_name,
        model_alias,
        factory_name,
        sales_name,
        displacement,
      } = this.$route.query;
      const basic_info = {
        choose_vehicle_id: this.vehicle_id,
        menu_type: 3,
        uuid: uuid,
        scheme_id: this.$route.query.scheme_id,
        search_type:
          internal_from === "photo_vin"
            ? 2
            : internal_from === "text_vin"
            ? 3
            : 1,
        brand_name,
        model_alias,
        displacement,
        factory_name,
        sales_name,
      };
      await userQueryCarModelRecord.apply(this, [basic_info]);
    },
  },
};
</script>
<style lang="less" scoped>
.tire-recommend {
  display: flex;
  background-color: #fafafa;
  flex-direction: column;
  .all-empty {
    height: 90vh;
    display: flex;
    justify-content: center;
    .empty-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      .empty-img {
        margin-top: 208/100rem;
        width: 191/100rem;
        height: 191/100rem;
      }
      span {
        margin-top: 26/100rem;
        font-size: 27/100rem;
        color: #7f7f7f;
      }
    }
  }
  .model-name {
    color: #404040;
    font-size: 27/100rem;
    margin: 34/100rem auto 34/100rem 17/100rem;
  }
  .basic-info {
    display: flex;
    background-color: #fff;
    padding: 26/100rem 17/100rem;
    flex-direction: column;
    // height: 401/100rem;
    margin-bottom: 26/100rem;
    .sub-title {
      margin-bottom: 34/100rem;
      color: #404040;
      font-size: 27/100rem;
      font-weight: 600;
    }
    .single-box {
      justify-content: center;
    }
    .two-box {
      justify-content: space-between;
      padding: 0 20/100rem;
    }
    .three-box {
      overflow-x: scroll;
      overflow: -moz-scrollbars-none;
      -ms-overflow-style: none;
      .product-box {
        width: 184/100rem;
      }
    }
    .products-box {
      display: flex;
      height: auto;
      .product-box {
        overflow: auto;
        width: 258/100rem;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        color: #404040;
        font-size: 24/100rem;
        align-items: center;
        text-align: center;
        img {
          width: 184/100rem;
          height: 184/100rem;
          margin-bottom: 26/100rem;
          box-shadow: 0px 3/100rem 20/100rem 0px rgba(0, 0, 0, 0.05);
          border-radius: 9/100rem;
        }
        span {
          box-sizing: content-box;
        }
      }
    }
    .products-box::-webkit-scrollbar {
      width: 0 !important;
    }
    .empty {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      .empty-box {
        display: flex;
        flex-direction: column;
        img {
          width: 157/100rem;
          height: 157/100rem;
        }
        span {
          margin-top: 12/100rem;
          color: #7f7f7f;
          font-size: 27/100rem;
          margin-bottom: 20/100rem;
        }
      }
    }
  }
  .spec {
    width: 100%;
    background-color: #fff;
    height: 372/100rem;
    padding: 26/100rem 17/100rem;
    display: flex;
    flex-direction: column;
    margin-bottom: 26/100rem;
    .sub-title {
      margin-bottom: 17/100rem;
      color: #404040;
      font-size: 27/100rem;
      font-weight: 600;
    }
    table {
      border: 2/100rem solid #f0f0f0;
      border-collapse: collapse;
      font-size: 24/100rem;
      color: #404040;
      td,
      th {
        border-collapse: collapse;
        border: 2/100rem solid #f0f0f0;
        width: 50%;
        text-align: center;
        height: 87/100rem;
      }
      .content {
        color: #a1a1a1;
      }
    }
  }
  .tire-pressure {
    height: auto;
    display: flex;
    background-color: #fff;
    flex-direction: column;
    padding: 26/100rem 17/100rem;
    margin-bottom: 26/100rem;
    .sub-title {
      color: #404040;
      font-size: 27/100rem;
      font-weight: 600;
      margin-bottom: 17/100rem;
    }
    .item {
      border-bottom: 2/100rem #f0f0f0 solid;
      min-height: 85/100rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24/100rem;
      .left {
        color: #404040;
        white-space: nowrap;
        margin-right: 30/100rem;
      }
      .right {
        color: #a1a1a1;
      }
    }
    .multiple {
      align-items: start;
      padding: 30/100rem 0;
      line-height: 35/100rem;
    }
  }
}
</style>
